import { useTranslation } from "react-i18next";

const DropdownErrorPage = ({
    title = "page_not_found_title",
    description = "page_not_found_description"
}) => {
    // Keep only the "Resources" card as an example
    const navigations = [

    ];
    const { t } = useTranslation("not_found"); // Hook to use translations

    return (
        <div className="fixed left-0 top-[102px] w-screen z-50 bg-black shadow-lg max-h-[80vh] overflow-y-auto">
            <div className="max-w-screen-2xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 py-10 px-5 sm:px-10 md:px-20">
                <div className="col-span-3">
                    <div className="space-y-3 text-center mb-12">
                        <h3 className="text-[#05897e] font-semibold text-4xl">{t("error_404_title")}</h3>
                        <p className="text-color-5 text-3xl font-semibold sm:text-4xl">{t(title)}</p>
                        <p className="text-color-1"> {t(description)}</p>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                        {navigations.map((item, idx) => (
                            <div key={idx} className="p-4 bg-[#FFFFFF3D] rounded-[8px] backdrop-blur-[10px]">
                                <div className="flex gap-x-4 mb-4">
                                    <div className="flex-none w-14 h-14 border border-[#f0f0f0b2] rounded-full text-[#05897e] flex items-center justify-center">
                                        {item.icon}
                                    </div>
                                    <div className="space-y-1">
                                        <h4 className="text-color-5 text-gray-800 font-medium">{t(item.title)}</h4>
                                        <p className="text-color-1">{t(item.desc)}</p>
                                        <a href={item.href} className="text-sm text-[#05897e] duration-150 hover:text-[#046e63] font-medium inline-flex items-center gap-x-1">
                                        {t("learn_more")}
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5">
                                                <path fillRule="evenodd" d="M5 10a.75.75 0 01.75-.75h6.638L10.23 7.29a.75.75 0 111.04-1.08l3.5 3.25a.75.75 0 010 1.08l-3.5 3.25a.75.75 0 11-1.04-1.08l2.158-1.96H5.75A.75.75 0 015 10z" clipRule="evenodd" />
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DropdownErrorPage;
